// Ids come from insert order in 20260523000001_seed_enumerations (a plain serial, not a pinned
// literal) -- verified against a live database rather than assumed.
export var AssocPriceType;
(function (AssocPriceType) {
    AssocPriceType[AssocPriceType["PERCENTAGE"] = 1] = "PERCENTAGE";
    AssocPriceType[AssocPriceType["FLAT"] = 2] = "FLAT";
})(AssocPriceType || (AssocPriceType = {}));
//# sourceMappingURL=assoc-price-type.js.map